
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";

interface ProtectedRouteProps {
  children: ReactNode;
  checkRole?: (user: any) => boolean;
}

export const ProtectedRoute = ({ children, checkRole }: ProtectedRouteProps) => {
  const { isAuthenticated, user } = useAuthStore();

  // First check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Then check if specific role is required
  if (checkRole && !checkRole(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
